import Input from "./Input";
import Inputs from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import Button from "./Button";
import ActionButton from "./ActionButton";

const Controls = {
  Input,
  Inputs,
  RadioGroup,
  Select,
  Checkbox,
  DatePicker,
  Button,
  ActionButton,
};

export default Controls;
